/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemSpecialityGroupViewModel } from '../../models/system-speciality-group-view-model';

export interface ApiAdminSystemSpecialityGroupsIdGet$Params {
  id: string;
}

export function apiAdminSystemSpecialityGroupsIdGet(http: HttpClient, rootUrl: string, params: ApiAdminSystemSpecialityGroupsIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<SystemSpecialityGroupViewModel>> {
  const rb = new RequestBuilder(rootUrl, apiAdminSystemSpecialityGroupsIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<SystemSpecialityGroupViewModel>;
    })
  );
}

apiAdminSystemSpecialityGroupsIdGet.PATH = '/api/Admin/system-speciality-groups/{id}';
